import React from "react";
import style from "./ButtonIcon.module.scss";
import { Oval } from "react-loader-spinner";
import useDomainStore from "../../stores/domain";

function ButtonIcon({
  children,
  bgColor,
  onClick,
  textColor = "#000",
  className,
  disabled = false,
  size = "medium",
  isLoading = false,
  type = "button",
  ...props
}) {
  const { isKurvDomain } = useDomainStore();
  
  // Override bgColor for Kurv domain
  let finalBgColor = bgColor;
  if (isKurvDomain) {
    if (bgColor === "#4C70EF") {
      finalBgColor = "#22A276";
    } else if (bgColor === "#EDEDF4") {
      finalBgColor = "#DBE4E4";
    }
  }
  
  // Override textColor for Kurv domain if it's a text button (no bgColor) and default blue text
  const finalTextColor = isKurvDomain && !bgColor && textColor === "#254FE2" ? "#22A276" : textColor;
  
  return (
    <button
      className={`${size == "medium" ? style.button : size == "large" ? style.button_large : style.button_small} ${className}`}
      style={{
        backgroundColor: finalBgColor,
        color: finalTextColor,
      }}
      onClick={onClick}
      disabled={disabled || isLoading}
      type={type}
      {...props}
    >
      {isLoading && (
        <Oval
          visible={true}
          height="16"
          width="16"
          color="#FFF"
          ariaLabel="oval-loading"
          strokeWidth="6"
          strokeWidthSecondary="6"
        />
      )}
      {children}
    </button>
  );
}

export default ButtonIcon;
